import React from "react";
import { Document, Page, Text, View, Image, StyleSheet } from "@react-pdf/renderer";
import logo from "../../../assets/LandingImages/logo.png"; // Replace with the actual logo path

const AdmitCard = ({ userData, district, eventTitle, date, time, registrationId }) => {
    
    function convertTo12Hour(time24) {
        const [hour, minute] = time24.split(":");
        const hourNum = parseInt(hour, 10);
        const period = hourNum >= 12 ? "PM" : "AM";
        const hour12 = hourNum % 12 || 12;
        return `${String(hour12).padStart(2, "0")}:${minute} ${period}`;
    }

    return (
        <Document>
            <Page style={styles.page}>
                
                {/* Background Logo with Reduced Opacity */}
                <Image style={styles.backgroundLogo} src={logo} />

                {/* Header with Event Logo and Name */}
                <View style={styles.headerContainer}>
                    <Image style={styles.logo} src={logo} />
                    <View style={styles.titleContainer}>
                        <Text style={styles.titleText}>UDYAMA 1.0</Text>
                        <Text style={styles.subtitleText}>2024</Text>
                    </View>
                </View>

                {/* Event Details */}
                <View style={styles.eventContainer}>
                    <Text style={styles.dateText}>{date || "Date"}</Text>
                    <Text style={styles.timeText}>{convertTo12Hour(time) || "Time"}</Text>
                    <Text style={styles.eventTitle}>{eventTitle || "Event Title"}</Text>
                </View>

                {/* Enrollment Number */}
                <Text style={styles.enrollmentText}>
                    Event Registration Id: {registrationId ? registrationId.substring(0, 8).toUpperCase() : "N/A"}
                </Text>

                {/* Main Card with Details */}
                <View style={styles.cardContainer}>
                    <View style={styles.detailsContainer}>
                        <View style={styles.row}>
                            <Text style={styles.fieldLabel}>Name:</Text>
                            <Text style={styles.fieldValue}>{userData?.username || "N/A"}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.fieldLabel}>Role:</Text>
                            <Text style={styles.fieldValue}>{userData.role || "N/A"}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.fieldLabel}>Email:</Text>
                            <Text style={styles.fieldValue}>{userData?.email || "N/A"}</Text>
                        </View>
                        <View style={styles.row}>
                            <Text style={styles.fieldLabel}>Phone no:</Text>
                            <Text style={styles.fieldValue}>{userData?.phoneNumber || "N/A"}</Text>
                        </View>
                        {userData?.role !== "INDUSTRY" ? (
                            <>
                                <View style={styles.row}>
                                    <Text style={styles.fieldLabel}>College:</Text>
                                    <Text style={styles.fieldValue}>{userData?.collegeName || "N/A"}</Text>
                                </View>
                                <View style={styles.row}>
                                    <Text style={styles.fieldLabel}>District:</Text>
                                    <Text style={styles.fieldValue}>{district || "N/A"}</Text>
                                </View>
                            </>
                        ) : (
                            <>
                                <View style={styles.row}>
                                    <Text style={styles.fieldLabel}>Company Name:</Text>
                                    <Text style={styles.fieldValue}>{userData?.companyName || "N/A"}</Text>
                                </View>
                            </>
                        )}
                    </View>
                    <View style={styles.imageContainer}>
                        {userData && userData.image ? (
                            <Image
                                style={styles.profileImage}
                                src={`${process.env.REACT_APP_SERVER_BASE_URL}/${userData.image}`}
                            />
                        ) : (
                            <Text style={styles.noImageText}>No Image Available</Text>
                        )}
                    </View>
                </View>

                {/* Footer */}
                <Text style={styles.footerText}>
                    This is an automatically generated admit card for official use only.
                </Text>
            </Page>
        </Document>
    );
};

const styles = StyleSheet.create({
    page: {
        padding: 30,
        backgroundColor: "#E8F1FA",
        fontFamily: "Helvetica",
    },
    headerContainer: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid #8f919b",
        paddingBottom: 20,
        marginBottom: 20, // Increased spacing below the header
    },
    logo: {
        width: 50,
        height: 50,
    },
    backgroundLogo: {
        position: "absolute",
        top: "37%",
        left: "28%",
        width: "55%",
        height: "auto",
        opacity: 0.1,
    },
    titleContainer: {
        textAlign: "center",
        marginLeft: 10,
    },
    titleText: {
        fontSize: 26,
        fontWeight: "bold",
        color: "#05194c",
    },
    subtitleText: {
        fontSize: 16,
        color: "#05194c",
    },
    eventContainer: {
        textAlign: "center",
        marginVertical: 18, // Added spacing above and below the event details
        padding: 15,
        backgroundColor: "#05194c",
        color: "#FFF",
        borderRadius: 5,
    },
    dateText: {
        fontSize: 14,
    },
    timeText: {
        fontSize: 14,
        marginBottom: 8, // Increased margin between time and title
    },
    eventTitle: {
        fontSize: 18,
        fontWeight: "bold",
    },
    enrollmentText: {
        fontWeight: "bold",
        marginVertical: 15, // Increased vertical margin
        textAlign: "center",
        fontSize: 16,
        color: "#05194c",
        borderBottom: "1px solid #8f919b",
        paddingBottom: 15, // Increased padding below text
    },
    cardContainer: {
        flexDirection: "row",
        border: "1px solid #8f919b",
        borderRadius: 5,
        padding: 15, // Increased padding inside the card
        marginTop: 20, // Increased margin above the card
    },
    detailsContainer: {
        flex: 2,
    },
    row: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 10, // Increased spacing between rows
    },
    fieldLabel: {
        fontSize: 12,
        color: "#555",
        fontWeight: "bold",
        width: "30%",
    },
    fieldValue: {
        fontSize: 12,
        color: "#333",
        width: "70%",
    },
    imageContainer: {
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        paddingLeft: 15,
    },
    profileImage: {
        width: 85,
        height: 85,
        borderRadius: "50%",
        border: "1px solid #8f919b",
    },
    noImageText: {
        fontSize: 12,
        color: "#777",
    },
    footerText: {
        textAlign: "center",
        fontSize: 10,
        color: "#999",
        marginTop: 30, // Increased margin above the footer text
        borderTop: "1px solid #8f919b",
        paddingTop: 10, // Increased padding above footer text
    },
});


export default AdmitCard;
